export const deadlinesTabMeta = {
  id: "deadlines",
  label: "Deadline LMS",
  shortLabel: "DL",
};
